import React, { useState, useEffect } from 'react';
import loadingImage from '../../Assests/images/logo/loading.png'; 

const PreLoader = () => {
  const [isLoading, setIsLoading] = useState(true); 

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer); 
  }, []);

  return (
    isLoading && (
      <div id="loading">
        <div id="loading-center">
          <div className="loader-container">
            <div className="wrap-loader">
              <div className="loader"></div>
              <div className="icon">
                <img src={loadingImage} 
                alt="CoOwnSpace Loading..." 
                loading="lazy"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default PreLoader;
